import React from 'react';
import TestEngine from './components/TestEngine';
import './index.css';

function App() {
  return <TestEngine />;
}

export default App;
